{
  /* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number: Modal component */
}
import { memo, useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  BzModal,
  BzModalBody,
  BzModalHeader,
} from '../../components';
import { handleModal } from '../../redux/actions/modals';
import { LoginLoader } from '../Login';
import ZeroStates from '../ZeroStates';
const SegmentWiseVersionModal = () => {
  const modals = useSelector((state) => state?.modals?.modals);
  const segmentVersionRes = useSelector((state)=>state.notification.segmentVersionNo)
  const isLoading = useSelector((state) => state.auth.isLoading);
  const [loading, setLoading] = useState(true);
  const [modalData, setModalData] = useState([]);
  useEffect(() => {
    if (segmentVersionRes?.data) setModalData([...segmentVersionRes.data]);
  }, [segmentVersionRes]);
  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);
  const dispatch = useDispatch();

  const onHide = () => {
    dispatch(handleModal([{ SEGMENT_WISE_VERSION: false }]));
  };
  return (
    <BzModal size="md" show={modals['SEGMENT_WISE_VERSION']} onHide={onHide} id="SegmentVersion" role="dialog" aria-hidden="true">
      <BzModalHeader className="modaltabs-header">
        <Container fluid className='p-0'>
          <Row className='g-0 align-items-center'>
            <Col md={11} className='d-flex justify-content-start align-items-center'>
              <div data-testid='modal-title' className='font-medium font-size4 color-text'>Segment Wise Version</div>
            </Col>
            <Col md={1} className='d-flex justify-content-end align-items-center'>
               <div data-testid='modal-close' className='icon-16 icon-close icon-dark' onClick={onHide}></div>
            </Col>
          </Row>
        </Container>
      </BzModalHeader>
      <BzModalBody> {loading ? (<div className="p-5"> <LoginLoader spinner={loading}/></div>) : (  
        <Container fluid className='p-0 p-2'>          
            {modalData.length > 0 &&
            <Row className='g-0 bdr-btm-secondary pb-3'>
              <Col data-testid='heading-sname' className='font-medium font-size4 color-text text-start'>Segment Name</Col>
              <Col data-testid='heading-vno' className='font-medium font-size4 color-text text-end'>Version No</Col>
            </Row> } 
                  
         </Container>     
        )}
        <Container fluid className='p-0 p-2'>          
            {modalData.length > 0 && !loading? ( modalData.map((item,index) => { return (
                    <Row key={`${item.sVersionNo+index}`} className='g-0 align-items-center mb-2'>
                      <Col data-testid='segment-name' className='font-medium font-size4 color-text text-start'>{item.sSegmentName}</Col>
                      <Col data-testid='segment-version' className='font-regular font-size4 color-text text-end'>{item.sVersionNo}</Col>
                    </Row>
                  );
                })
              ) : (
                <div data-testid='no-data-found' className='zero-state-alerts zero-state-alerts-md'>
                  <ZeroStates subText="No Data Found" icon='icon-64 icon-nodata mb-3 mrgauto'/>
                </div>
              )}            
        </Container>
      </BzModalBody>
    </BzModal>
  );
};
export default memo(SegmentWiseVersionModal);
